import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexClipboard',
  setup(__props) {

const textInput = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/clipboard/textInput.vue"))
const textArea = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/clipboard/textArea.vue"))
const paraGraph = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/clipboard/paraGraph.vue"))
const copyPortion = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/clipboard/copyPortion.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Form Widgets",
      title: "Clipboard"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(textInput)),
        _createVNode(_unref(textArea)),
        _createVNode(_unref(paraGraph)),
        _createVNode(_unref(copyPortion))
      ])
    ])
  ], 64))
}
}

})